<nz-table
  #table
  nzSize="small"
  [nzBordered]="true"
  nzShowPagination
  nzShowSizeChanger
  [nzPageSize]="20"
  [nzData]="views"
  [nzPageSizeOptions]="[10, 20, 30, 40, 50]"
>
  <thead>
    <tr>
      <th nzWidth="1px">#</th>
      <th nzWidth="150px">{{ 'LOT_EVENTS.VIEWS.VIEW_DATE' | translate }}</th>
      <th nzWidth="150px">{{ 'LOT_EVENTS.VIEWS.USER_ID' | translate }}</th>
      <th>{{ 'LOT_EVENTS.VIEWS.USER' | translate }}</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let view of table.data; index as i">
      <td>{{ views.length - (i + (table.nzPageIndex - 1) * table.nzPageSize) | number }}</td>
      <td>{{ view.createdAt | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
      <td>{{ view.user.id }}</td>
      <td>
        <a
          target="__blank"
          [href]="managerDomain + '/akebono-auctioneer/users/edit/' + view.user.id"
        >
          {{ view.user.fullName }}
          ({{ view.user.username }})
        </a>
      </td>
    </tr>
  </tbody>
</nz-table>
